import { AppGold, NotificationGold, TipGold } from '@ice-web-app/assets';
import { DsBadge, DsTooltip } from '@ice-web-app/designSystem';
import { TIPS } from '@ice-web-app/shared-constants';
import { usePopover, useTranslation } from '@ice-web-app/shared-hooks';
import { useTourStore } from '@ice-web-app/shared-store';
import { CircleGoldBorder } from '@ice-web-app/shared-ui';
import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import { DsIcon } from '../../../../components/icons/DsIcon';
import HeaderAppDropDown from '../horizontal/HeaderAppDropDown';
import UserDropdown from '../shared/UserDropdown';

const ActionMenu = () => {
  const { t } = useTranslation();
  const { setTourProps, tourProps } = useTourStore();
  const [showBadge, _setShowBadge] = useState(false);

  const notificationsPopover = usePopover();
  const appsPopover = usePopover();

  return (
    <>
      <Stack direction="row" gap={4} justifyContent="right" flex={{ xs: 1, lg: 'none' }}>
        <DsTooltip title="Notification">
          <Box
            component="button"
            sx={{ position: 'relative', display: 'inline-block' }}
            onClick={(e) => {
              notificationsPopover.onOpen(e);
            }}
          >
            <CircleGoldBorder isActive={notificationsPopover.open}>
              {notificationsPopover.open ? <NotificationGold /> : <DsIcon icon="NOTIFICATION" size={24} />}
            </CircleGoldBorder>
            {showBadge && (
              <DsBadge
                color="error"
                variant="dot"
                sx={{
                  position: 'absolute',
                  top: 6,
                  right: 6,
                  transform: 'translate(50%, -50%)',
                }}
              />
            )}
          </Box>
        </DsTooltip>

        <DsTooltip title={t('TIPS')}>
          <Box
            data-tour={TIPS.LAYOUT.HEADER.TOUR_TIPS_BUTTON.DATA}
            component="button"
            onClick={() => setTourProps({ isOpen: !!tourProps.steps?.length })}
          >
            <CircleGoldBorder
              isActive={tourProps.isOpen}
              border={tourProps.steps?.length ? 'gold' : 'normal'}
              sx={{ cursor: tourProps.steps?.length ? 'pointer' : 'default' }}
            >
              {tourProps.isOpen ? <TipGold /> : <DsIcon icon="T_TIP" sx={{ fontWeight: 900 }} />}
            </CircleGoldBorder>
          </Box>
        </DsTooltip>
        <DsTooltip title="Tooltip">
          <Box
            component="button"
            onClick={(e) => {
              appsPopover.onOpen(e);
            }}
          >
            <CircleGoldBorder isActive={appsPopover.open}>
              {appsPopover.open ? <AppGold /> : <DsIcon icon="APPS" size={24} />}
            </CircleGoldBorder>
          </Box>
        </DsTooltip>
      </Stack>
      <UserDropdown />
      <HeaderAppDropDown popover={appsPopover} />
    </>
  );
};
export default ActionMenu;
